import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I'm <span className="purple">Reza Ananda</span>, an Information
            Systems graduate from{" "}
            <span className="purple">North Sumatra, Indonesia</span>. I am
            passionate about software development, artificial intelligence,
            Internet of Things (IoT), and data-driven technologies. Throughout
            my academic journey, internships, and research experiences, I have
            built practical solutions while continuously improving my technical,
            analytical, and leadership skills. Here are some milestones that
            represent my academic and professional journey:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Best Graduate of the Information Systems Program,
              (GPA: 3.92/4.00).
            </li>

            <li className="about-activity">
              <ImPointRight /> Graduate with Academic Distinction
            </li>

            <li className="about-activity">
              <ImPointRight /> Completed Two National Programs by
              Kemendikbudristek.
            </li>

            <li className="about-activity">
              <ImPointRight /> Internship Experience in Software Engineering,
              Programming, IT Support, and Research.
            </li>

            <li className="about-activity">
              <ImPointRight /> Skilled in Web Development, AI, IoT, and Machine
              Learning.
            </li>
          </ul>

          <p style={{ color: "rgb(155, 126, 172)" }}>
            <i>
              "Learning never stops, and every challenge is an opportunity to
              build technology that creates meaningful impact."
            </i>
          </p>

          <footer className="blockquote-footer">Reza Ananda</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
